import { render, staticRenderFns } from "./InventoryReorderStatus.vue?vue&type=template&id=0a4d3d8c&"
import script from "./InventoryReorderStatus.vue?vue&type=script&lang=js&"
export * from "./InventoryReorderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports